import tw, { styled } from 'twin.macro';

const Geolocate = styled.div`
  ${tw`absolute left-0 top-0`}
  padding: 10px
`;

export default Geolocate;
